import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const DepositproductAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		productname: yup.string().required().label($t('productname')),
		deposit_type: yup.string().nullable().label($t('depositType')),
		amount: yup.number().nullable().label($t('amount')),
		interestrate: yup.number().required().label($t('interestrate')),
		processingfee: yup.number().required().label($t('processingfee')),
		frequency: yup.string().nullable().label($t('frequency')),
		term_period: yup.number().nullable().label($t('termPeriod')),
		amort_type: yup.string().nullable().label($t('amortType')),
		compounding: yup.string().nullable().label($t('compounding'))
	});
	
	//form default values
	const formDefaultValues = {
		productname: '', 
		deposit_type: '', 
		amount: '', 
		interestrate: "((0))", 
		processingfee: "((0))", 
		frequency: '', 
		term_period: '', 
		amort_type: '', 
		compounding: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/depositproduct`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="DepositproductAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewDepositproduct')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('productname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="productname"  onChange={formik.handleChange}  value={formik.values.productname}   label={$t('productname')} type="text" placeholder={$t('enterProductname')}        className={inputClassName(formik?.errors?.productname)} />
                                                <ErrorMessage name="productname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('depositType')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="deposit_type"     optionLabel="label" optionValue="value" value={formik.values.deposit_type} onChange={formik.handleChange} options={app.menus.depositType} label={$t('depositType')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.deposit_type)}   />
                                                <ErrorMessage name="deposit_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('amount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="amount"  onChange={formik.handleChange}  value={formik.values.amount}   label={$t('amount')} type="number" placeholder={$t('enterAmount')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.amount)} />
                                                <ErrorMessage name="amount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('interestrate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="interestrate"  onChange={formik.handleChange}  value={formik.values.interestrate}   label={$t('interestrate')} type="number" placeholder={$t('enterInterestrate')}  min={0}  step={0.01}    className={inputClassName(formik?.errors?.interestrate)} />
                                                <ErrorMessage name="interestrate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('processingfee')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="processingfee"  onChange={formik.handleChange}  value={formik.values.processingfee}   label={$t('processingfee')} type="number" placeholder={$t('enterProcessingfee')}  min={0}  step={0.01}    className={inputClassName(formik?.errors?.processingfee)} />
                                                <ErrorMessage name="processingfee" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('frequency')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="frequency"     optionLabel="label" optionValue="value" value={formik.values.frequency} onChange={formik.handleChange} options={app.menus.frequency} label={$t('frequency')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.frequency)}   />
                                                <ErrorMessage name="frequency" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('termPeriod')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="term_period"  onChange={formik.handleChange}  value={formik.values.term_period}   label={$t('termPeriod')} type="number" placeholder={$t('enterTermPeriod')}  min={0}  step="any"    className={inputClassName(formik?.errors?.term_period)} />
                                                <ErrorMessage name="term_period" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('amortType')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="amort_type"     optionLabel="label" optionValue="value" value={formik.values.amort_type} onChange={formik.handleChange} options={app.menus.amortType} label={$t('amortType')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.amort_type)}   />
                                                <ErrorMessage name="amort_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('compounding')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="compounding"     optionLabel="label" optionValue="value" value={formik.values.compounding} onChange={formik.handleChange} options={app.menus.compounding} label={$t('compounding')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.compounding)}   />
                                                <ErrorMessage name="compounding" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
DepositproductAddPage.defaultProps = {
	primaryKey: 'productid',
	pageName: 'depositproduct',
	apiPath: 'depositproduct/add',
	routeName: 'depositproductadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default DepositproductAddPage;
